// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select_selectContainer__mVKkP {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  -webkit-user-select: none;
          user-select: none;
}
.Select_selectContainer__mVKkP.Select_disabled__YO4gI {
  opacity: 0.6;
  pointer-events: none;
}

.Select_label__NPl7G {
  font-weight: 500;
  color: var(--color-text-subtle);
}

.Select_select__aeuTF {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--color-surface-interactive);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-default);
  min-height: 2.5rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.Select_select__aeuTF:hover, .Select_select__aeuTF:focus-visible {
  border-color: var(--color-border-highlight);
}
.Select_select__aeuTF:focus, .Select_select__aeuTF:focus-visible, .Select_select__aeuTF.Select_open__Sbswz {
  outline: none;
  border-color: var(--color-border-active);
}

.Select_selectedValue__uSnqb {
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
}
.Select_selectedValue__uSnqb.Select_placeholder__TrKbk {
  color: var(--color-text-subtle);
}

.Select_arrow__8HYdA {
  display: flex;
  align-items: center;
  margin-left: calc(var(--gutter) / 2);
  color: var(--color-text-subtle);
}

.Select_arrowIcon__9sf1K {
  transition: transform 0.15s;
}
.Select_arrowIcon__9sf1K.Select_open__Sbswz {
  transform: rotate(180deg);
}

.Select_dropdown__P56Tv {
  position: absolute;
  top: calc(100% + 0.25rem);
  left: 0;
  width: 100%;
  max-height: 300px;
  background: var(--color-surface-light);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-default);
  box-shadow: var(--box-shadow);
  z-index: 100;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.Select_searchContainer__RrPZ8 {
  padding: calc(var(--gutter) / 2);
  border-bottom: 1px solid var(--color-border);
}

.Select_search__R5qHC {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-default);
  background: var(--color-surface-interactive);
}
.Select_search__R5qHC:focus, .Select_search__R5qHC:focus-visible {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px rgba(var(--color-primary-rgb, 0, 0, 0), 0.15);
}

.Select_options__3FopM {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 220px;
  overflow-y: auto;
}
.Select_options__3FopM::-webkit-scrollbar {
  width: 8px;
}
.Select_options__3FopM::-webkit-scrollbar-track {
  background: transparent;
}
.Select_options__3FopM::-webkit-scrollbar-thumb {
  background-color: var(--color-border);
  border-radius: 4px;
  border: 2px solid var(--color-surface-light);
}

.Select_option__a4nLv {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: background-color 0.1s;
  outline: none;
}
.Select_option__a4nLv:hover, .Select_option__a4nLv.Select_highlighted__\\+Q1JE, .Select_option__a4nLv:focus, .Select_option__a4nLv:focus-visible {
  background-color: var(--color-surface-interactive);
}
.Select_option__a4nLv.Select_selected__KzILi {
  background-color: var(--color-surface-darker);
  font-weight: 500;
}
.Select_option__a4nLv:focus, .Select_option__a4nLv:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: -2px;
  z-index: 1;
  position: relative;
}

.Select_noOptions__Uofrt {
  padding: 0.75rem;
  color: var(--color-text-subtle);
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Select/Select.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;AACF;AACE;EACE,YAAA;EACA,oBAAA;AACJ;;AAGA;EACE,gBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4CAAA;EACA,qCAAA;EACA,oCAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gDAAA;AAAF;AAEE;EACE,2CAAA;AAAJ;AAGE;EACE,aAAA;EACA,wCAAA;AADJ;;AAKA;EACE,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AAFF;AAIE;EACE,+BAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,+BAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,yBAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,sCAAA;EACA,qCAAA;EACA,oCAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAJF;;AAOA;EACE,gCAAA;EACA,4CAAA;AAJF;;AAOA;EACE,WAAA;EACA,eAAA;EACA,qCAAA;EACA,oCAAA;EACA,4CAAA;AAJF;AAME;EACE,aAAA;EACA,kCAAA;EACA,mEAAA;AAJJ;;AAQA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;AALF;AAOE;EACE,UAAA;AALJ;AAQE;EACE,uBAAA;AANJ;AASE;EACE,qCAAA;EACA,kBAAA;EACA,4CAAA;AAPJ;;AAWA;EACE,uBAAA;EACA,eAAA;EACA,iCAAA;EACA,aAAA;AARF;AAUE;EACE,kDAAA;AARJ;AAWE;EACE,6CAAA;EACA,gBAAA;AATJ;AAYE;EACE,uCAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;AAVJ;;AAcA;EACE,gBAAA;EACA,+BAAA;EACA,kBAAA;AAXF","sourcesContent":[".selectContainer {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n  user-select: none;\n  \n  &.disabled {\n    opacity: 0.6;\n    pointer-events: none;\n  }\n}\n\n.label {\n  font-weight: 500;\n  color: var(--color-text-subtle);\n}\n\n.select {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--color-surface-interactive);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-default);\n  min-height: 2.5rem;\n  padding: 0.5rem 0.75rem;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  \n  &:hover, &:focus-visible {\n    border-color: var(--color-border-highlight);\n  }\n  \n  &:focus, &:focus-visible, &.open {\n    outline: none;\n    border-color: var(--color-border-active);\n  }\n}\n\n.selectedValue {\n  color: var(--color-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  \n  &.placeholder {\n    color: var(--color-text-subtle);\n  }\n}\n\n.arrow {\n  display: flex;\n  align-items: center;\n  margin-left: calc(var(--gutter) / 2);\n  color: var(--color-text-subtle);\n}\n\n.arrowIcon {\n  transition: transform 0.15s;\n  \n  &.open {\n    transform: rotate(180deg);\n  }\n}\n\n.dropdown {\n  position: absolute;\n  top: calc(100% + 0.25rem);\n  left: 0;\n  width: 100%;\n  max-height: 300px;\n  background: var(--color-surface-light);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-default);\n  box-shadow: var(--box-shadow);\n  z-index: 100;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.searchContainer {\n  padding: calc(var(--gutter) / 2);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.search {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-default);\n  background: var(--color-surface-interactive);\n  \n  &:focus, &:focus-visible {\n    outline: none;\n    border-color: var(--color-primary);\n    box-shadow: 0 0 0 2px rgba(var(--color-primary-rgb, 0, 0, 0), 0.15);\n  }\n}\n\n.options {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 220px;\n  overflow-y: auto;\n  \n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-border);\n    border-radius: 4px;\n    border: 2px solid var(--color-surface-light);\n  }\n}\n\n.option {\n  padding: 0.5rem 0.75rem;\n  cursor: pointer;\n  transition: background-color 0.1s;\n  outline: none;\n  \n  &:hover, &.highlighted, &:focus, &:focus-visible {\n    background-color: var(--color-surface-interactive);\n  }\n  \n  &.selected {\n    background-color: var(--color-surface-darker);\n    font-weight: 500;\n  }\n  \n  &:focus, &:focus-visible {\n    outline: 2px solid var(--color-primary);\n    outline-offset: -2px;\n    z-index: 1;\n    position: relative;\n  }\n}\n\n.noOptions {\n  padding: 0.75rem;\n  color: var(--color-text-subtle);\n  text-align: center;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectContainer": `Select_selectContainer__mVKkP`,
	"disabled": `Select_disabled__YO4gI`,
	"label": `Select_label__NPl7G`,
	"select": `Select_select__aeuTF`,
	"open": `Select_open__Sbswz`,
	"selectedValue": `Select_selectedValue__uSnqb`,
	"placeholder": `Select_placeholder__TrKbk`,
	"arrow": `Select_arrow__8HYdA`,
	"arrowIcon": `Select_arrowIcon__9sf1K`,
	"dropdown": `Select_dropdown__P56Tv`,
	"searchContainer": `Select_searchContainer__RrPZ8`,
	"search": `Select_search__R5qHC`,
	"options": `Select_options__3FopM`,
	"option": `Select_option__a4nLv`,
	"highlighted": `Select_highlighted__+Q1JE`,
	"selected": `Select_selected__KzILi`,
	"noOptions": `Select_noOptions__Uofrt`
};
export default ___CSS_LOADER_EXPORT___;
